import { complexSelectorActions } from '../../services';

export const complexSelectorReducer = ( state= {complexSelectors : {}} , action ) => {
  switch ( action.type ) {
    case complexSelectorActions.SET:
      return { complexSelectors: {
        ...state.complexSelectors,
        [action.data.parentSelector]: action.data.targetSelector
      }}
    default:
      return state;
  }
};